export default __webpack_public_path__ + "static/media/instagram_logo.11bc03b3.svg";